var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNecktie(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.9999,
    height: 58.77788,
    viewBox: "0 0 51.9999 58.77788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8967aa;}.cls-2{fill:#92d3f5;stroke:#92d3f5;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-4{stroke-width:2px;}.cls-3{fill:#61b2e4;stroke:#61b2e4;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.9607,7.77788c-3.292,0-5.9607,2.6687-5.9607,5.9607V51.81708c0,3.292,2.6687,5.9607,5.9607,5.9607H45.0392c3.292,0,5.9607-2.6687,5.9607-5.9607V13.73858c0-3.292-2.6687-5.9607-5.9607-5.9607h-3.1635L31.5248,1.96398l-8.528-.2269-8.2214,2.3051-4.029,3.7356h-3.7857v.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.5587,6.59738s-4.6402,2.9574,6.4892,16.7221l3.9887-7.0302L15.2132,7.87508l-3.0873-3.0873"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.3598,5.36848l-2.4093,2.4093-7.1732,8.52,4.6605,7.0331c11.1293-13.7647,6.0484-16.3786,6.0484-16.3786"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.5079 25.62008 24.5005 25.62008 20.4751 57.77788 31.5248 57.77788 27.5079 25.62008"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.5079 18.66278 24.5005 18.66278 22.9968 22.14138 24.5005 25.62008 27.5079 25.62008 29.0117 22.14138 27.5079 18.66278"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.9607,7.77788c-3.292,0-5.9607,2.6687-5.9607,5.9607V51.81708c0,3.292,2.6687,5.9607,5.9607,5.9607H45.0392c3.292,0,5.9607-2.6687,5.9607-5.9607V13.73858c0-3.292-2.6687-5.9607-5.9607-5.9607"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.2132,7.87508l7.8234,8.4142-4.9887,8.0302C6.9186,10.55478,10.7295,6.77778,10.7295,6.77778c0,0,14.3783-13,30.6143,0,0,0,3.8109,3.7769-7.3184,17.5417l-4.9887-8.0302,7.9138-8.5115"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.5079 25.62008 24.5005 25.62008 20.4751 57.77788 31.5248 57.77788 27.5079 25.62008"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.5079 18.66278 24.5005 18.66278 22.9968 22.14138 24.5005 25.62008 27.5079 25.62008 29.0117 22.14138 27.5079 18.66278"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecktie);
export default __webpack_public_path__ + "static/media/necktie.e38bed2a7cb1cb7b57099d12a6ccd9f2.svg";
export { ForwardRef as ReactComponent };